import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled, { ThemeConsumer } from 'styled-components';
import AhLogo from './AhLogo';
import { findTimeZone, getZonedTime, format } from 'timezone-support';
import { toDate, format as formatTz, utcToZonedTime } from 'date-fns-tz';
import { nl as localeNL } from 'date-fns/locale';
import nl_flag from '../assets/images/flags/nl.svg';
import background1 from '../assets/images/work-backgrounds/klaasvaak.png';
import background2 from '../assets/images/work-backgrounds/wonderhotel.png';
import background3 from '../assets/images/work-backgrounds/pode.png';
import foreground from '../assets/images/work-backgrounds/pjotr-front.png';

const colors = {
  primary: '#F6F6F6',
  secundary: '#848484'
};

const FlexOuterWrapper = styled.div`
  font-family: ${props => false ? "'Danse Macabre', sans-serif" : "'Inter', sans-serif"};
  font-feature-settings: 'dlig' on;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.primary};
  justify-content: space-between;
  height: 100vh;
  background: ${props => (props.hoursLeft >= 2) ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${props.background})` : 'none'};
  background-size: cover;
  background-position: center; // Center the background image
  text-transform: ${props => false ? 'uppercase' : 'none'};
`;

const AlternateA = styled.span`
  font-variation-settings: 'ss01' on;
`;

const TopText = styled.div`
  font-size: 6vw;
  font-weight: 600;
  color: ${colors.secundary};
  margin-top: 5vw;
  text-shadow: 3px 3px 0 black, -3px -3px 0 black, 3px -3px 0 black, -3px 3px 0 black;
`;

const EndTime = styled.span`
  color: ${colors.primary};
`;

const CountdownWrapper = styled.div`
  font-family: 'Inter', sans-serif;
  text-transform: none;
  text-shadow: 5px 5px 0 black, -5px -5px 0 black, 5px -5px 0 black, -5px 5px 0 black;
`;

const CountdownValue = styled.span`
  font-size: 30vw;
  font-weight: 600;
  color: ${props => props.isRed ? '#FF3B30' : 'inherit'};
`;
const CountdownUnit = styled.span`
  font-size: 16vw;
  font-weight: 600;
  margin-left: 1.2vw;
  color: ${props => props.isRed ? '#FF3B30' : 'inherit'};
  /* text-transform: uppercase; */
`;

const CountdownVertrek = styled.span`
  text-transform: uppercase;
  font-size: 16vw;
  font-weight: 600;
`;

const BottomClock = styled.div`
  font-size: ${props => false ? '9vw' : '8vw'};
  font-weight: 600;
  margin-bottom: 5vw;
  text-shadow: 3px 3px 0 black, -3px -3px 0 black, 3px -3px 0 black, -3px 3px 0 black;
  transform: ${props => props.timeToLeave ? 'scale(1.4)' : 'scale(1)'};
  transform-origin: center bottom;
  transition: transform 3s ease-in-out;
`;

const SecundaryColor = styled.span`
  color: ${colors.secundary};
`;

const Flag = styled.img`
  border-radius: 0.9vw;
  height: 5.7vw;
  margin-right: 2vw;
  margin-top: 0.25vw;
  box-shadow: 3px 3px 0 black, -3px -3px 0 black, 3px -3px 0 black, -3px 3px 0 black;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${props => (props.hoursLeft >= 2) ? `url(${foreground})` : 'none'};
  background-size: cover;
  z-index: 999;
  pointer-events: none;
`;

const Countdown = props => {
  const { hoursLeft, minutesLeft, isRed } = props;
  // const hoursLeft = 0;
  // const minutesLeft = 34;

  // Calculate total minutes
  const totalMinutes = hoursLeft * 60 + minutesLeft;

  if (totalMinutes < 0) {
    return (<CountdownWrapper>
      <CountdownValue isRed={isRed}>{totalMinutes}</CountdownValue>
      <CountdownUnit isRed={isRed}>min</CountdownUnit>
    </CountdownWrapper>);
  }

  return (<CountdownWrapper>
    <CountdownValue isRed={isRed}>{totalMinutes}</CountdownValue>
    <CountdownUnit isRed={isRed}>min</CountdownUnit>
  </CountdownWrapper>);
};

class WorkBreak extends Component {
  constructor(props) {
    super(props);
    this.backgrounds = [background1, background2, background3];
    this.state = {
      background: this.backgrounds[Math.floor(Math.random() * this.backgrounds.length)]
    };
  }

  componentDidMount() {
    // Set initial timer
    this.switchBackgroundTimer = setInterval(() => {
      const currentIndex = this.backgrounds.indexOf(this.state.background);
      const nextIndex = (currentIndex + 1) % this.backgrounds.length;
      this.setState({
        background: this.backgrounds[nextIndex]
      });
    }, 5 * 60 * 1000); // 5 minutes in milliseconds
  }

  componentWillUnmount() {
    // Clear the timer when component unmounts
    if (this.switchBackgroundTimer) {
      clearInterval(this.switchBackgroundTimer);
    }
  }

  timeLeft = () => {
    // Check if break_start_time is null or undefined
    if (this.props.ahWorkShift.break_start_time == null) {
      return "Niet beschikbaar";
    }

    const amsterdamTimeZone = 'Europe/Amsterdam';
    const currentTime = new Date();

    // Calculate end time: start_time + 45 minutes
    const startTime = toDate(this.props.ahWorkShift.break_start_time);
    const endTime = new Date(startTime.getTime() + 45 * 60 * 1000); // Add 45 minutes

    const timeDifference = endTime - currentTime;

    const hoursLeft = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutesLeft = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    return { hoursLeft, minutesLeft };
  };

  timeLeftTo15Min = () => {
    // Check if break_start_time is null or undefined
    if (this.props.ahWorkShift.break_start_time == null) {
      return "Niet beschikbaar";
    }

    const amsterdamTimeZone = 'Europe/Amsterdam';
    const currentTime = new Date();

    // Calculate end time: start_time + 45 minutes
    const startTime = toDate(this.props.ahWorkShift.break_start_time);
    const endTime = new Date(startTime.getTime() + 45 * 60 * 1000); // Add 45 minutes

    // Calculate 15 minutes before end time
    const fifteenMinBeforeEnd = new Date(endTime.getTime() - 15 * 60 * 1000);

    const timeDifference = fifteenMinBeforeEnd - currentTime;

    const hoursLeft = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutesLeft = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    return { hoursLeft, minutesLeft };
  };

  toLocalTime = isoDateTimeString => {
    if (this.props.ahWorkShift.break_start_time == null) {
      return "?";
    }
    const amsterdamTimeZone = 'Europe/Amsterdam';
    const zonedTime = utcToZonedTime(isoDateTimeString, amsterdamTimeZone);
    const formattedTime = formatTz(zonedTime, 'HH:mm', { timeZone: amsterdamTimeZone, locale: localeNL });
    return formattedTime;
  };

  toLocalDayAndNumber = isoDateTimeString => {
    if (this.props.ahWorkShift.break_start_time == null) {
      return "?";
    }
    const amsterdamTimeZone = 'Europe/Amsterdam';
    const zonedTime = utcToZonedTime(isoDateTimeString, amsterdamTimeZone);
    const formattedDayAndNumber = formatTz(zonedTime, 'eee d', { timeZone: amsterdamTimeZone, locale: localeNL }).replace(/^(\w{2})\w/, '$1');
    return formattedDayAndNumber;
  };

  getBreakEndTimeParts = () => {
    if (this.props.ahWorkShift.break_start_time == null) {
      return { hour: '?', minute: '?' };
    }
    const amsterdamTimeZone = 'Europe/Amsterdam';
    const startTime = toDate(this.props.ahWorkShift.break_start_time);
    const endTime = new Date(startTime.getTime() + 45 * 60 * 1000); // Add 45 minutes
    const zonedTime = utcToZonedTime(endTime.toISOString(), amsterdamTimeZone);
    const formattedTime = formatTz(zonedTime, 'HH:mm', { timeZone: amsterdamTimeZone, locale: localeNL });
    const [hour, minute] = formattedTime.split(':');
    return { hour, minute };
  };

  render() {
    const timeStringNL = this.props.now && this.props.now.toLocaleTimeString('nl-NL', {
      hour12: false,
      hour: 'numeric',
      minute: 'numeric'
    });
    const temperature = (this.props.temperature != null) ? Math.round(this.props.temperature) : null;
    const { hoursLeft, minutesLeft } = this.timeLeft();
    const { hoursLeft: hoursLeftTo15, minutesLeft: minutesLeftTo15 } = this.timeLeftTo15Min();
    const timeToLeave = hoursLeft < 0 || minutesLeft < 0;

    // Determine which countdown to show and if it should be red
    const totalMinutesTo15 = hoursLeftTo15 * 60 + minutesLeftTo15;
    const totalMinutesToEnd = hoursLeft * 60 + minutesLeft;

    // If we're more than 15 minutes away from end time, count down to 15 minutes
    // If we're within 15 minutes of end time, count down to end time (red)
    const showRedCountdown = totalMinutesTo15 <= 0;
    const displayHours = showRedCountdown ? hoursLeft : hoursLeftTo15;
    const displayMinutes = showRedCountdown ? minutesLeft : minutesLeftTo15;

    const ahLogoColor = hoursLeft > 4 ? '#41619D' : '#3A4195';

    return (
      <FlexOuterWrapper hoursLeft={hoursLeft} background={this.state.background}>
        <TopText>
          <AhLogo color={ahLogoColor} /> pauze van {this.toLocalTime(this.props.ahWorkShift.break_start_time)} tot {' '}
          {(() => {
            const { hour, minute } = this.getBreakEndTimeParts();
            return <><span>{hour}</span><EndTime>:{minute}</EndTime></>;
          })()}
        </TopText>
        <Countdown hoursLeft={displayHours} minutesLeft={displayMinutes} isRed={showRedCountdown} />
        <BottomClock timeToLeave={timeToLeave} hoursLeft={hoursLeft}>
          <Flag src={nl_flag} />
          {timeStringNL}
          {temperature !== null && (
            <SecundaryColor> | {temperature}°</SecundaryColor>
          )}
        </BottomClock>
        {/* <Overlay hoursLeft={hoursLeft} /> */}
      </FlexOuterWrapper>
    );
  }
}

const mapStateToProps = state => ({
  now: state.time.now,
  temperature: state.weather.temperature,
  feelsLike: state.weather.feelsLike,
  emoji: state.weather.emoji,
  ahWorkShift: state.ahwork
});

export default connect(mapStateToProps)(WorkBreak); 